import { FC } from "react";
import Form from "react-bootstrap/Form";

// date-fns
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { DemoContainer, DemoItem } from "@mui/x-date-pickers/internals/demo";
import FormHelperText from "@mui/material/FormHelperText";
import FormControl from "@mui/material/FormControl";
import { MobileTimePicker } from "@mui/x-date-pickers/MobileTimePicker";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";

interface IMatTimePicker {
  controlId: string;
  label: string;
  placeholder?: string;
  handleChange?: any;
  handleBlur?: any;
  errorsField?: any;
  touched?: any;
  value: any;
  setValue?: any;
}

/**
 * Input Type Text Reusable Component
 *
 * @param {{ controlId: any; label: any; placeholder: any; handleChange: any; handleBlur: any; errorsField: any; touched: any; setValue: any }} {
    controlId, label, placeholder, handleChange, handleBlur, errorsField, touched
}
 * @returns {*}
 */
const MatTimePicker: FC<IMatTimePicker> = ({
  controlId,
  label,
  placeholder,
  handleChange,
  handleBlur,
  errorsField,
  touched,
  value,
  setValue,
}) => {
  return (
    <FormControl fullWidth error={errorsField && touched}>
      <Form.Group className="mb-3 pb-1" controlId={controlId}>
        <div className="position-relative time-picker-icon">
          <LocalizationProvider dateAdapter={AdapterMoment}>
            <DemoContainer
              components={["DateTimePicker", "MobileTimePicker", "TimePicker"]}
            >
              <DemoItem label=" ">
                <TimePicker
                  views={["hours", "minutes"]}
                  className="w-100 customDatePickerIcon"
                  value={value}
                  label={label}
                  onChange={handleChange}
                  // onError={errorsField}
                  defaultValue={value}
                />
              </DemoItem>
            </DemoContainer>
          </LocalizationProvider>
          <FormHelperText>
            {errorsField && touched ? errorsField : ""}
          </FormHelperText>
        </div>
      </Form.Group>
    </FormControl>
  );
};

export default MatTimePicker;
